import ProcessingOrb from "@/assets/img/compatibility/processing-orb.png"
import ProcessingRing from "@/assets/img/compatibility/processing-ring.svg"

import { ProcessingCore } from "./processing-core"
import type { StepComponentProps } from "./step-contract"

/**
 * "Calculating your Love Compatibility…" — the orb processing animation, then
 * straight on to the checkout. Thin wrapper over the shared ProcessingCore;
 * wired via the compatibility quiz's `stepOverrides.analysis`.
 */
export function CompatibilityProcessingStep({ step, onAdvance }: StepComponentProps) {
  return (
    <ProcessingCore
      orb={ProcessingOrb}
      ring={ProcessingRing}
      title={step.title}
      checklist={step.checklist ?? []}
      onComplete={onAdvance}
    />
  )
}
